import React from "react";
import PropTypes from "prop-types";
import {
  StyledPdfFilesDiv,
  StyledPdfFilesTitle,
  StyledPdfFilesIcon,
} from "./_.styled";
import ContentHeaderPdfFilesContainer from "./ContentHeaderPdfFilesContainer";

const ContentHeaderPdfFilesWrapper = ({
  pdfFiles,
  telemetryData,
  handleOpenPdf,
}) => (
  <StyledPdfFilesDiv>
    <StyledPdfFilesIcon
      icon={{
        color: "primary",
        glyph: "picture_as_pdf",
        size: "md",
      }}
    />
    <StyledPdfFilesTitle>Get PDF:</StyledPdfFilesTitle>
    <ContentHeaderPdfFilesContainer
      pdfFiles={pdfFiles}
      telemetryData={telemetryData}
      handleOpenPdf={handleOpenPdf}
    />
  </StyledPdfFilesDiv>
);

ContentHeaderPdfFilesWrapper.displayName = "ContentHeaderPdfFilesWrapper";

ContentHeaderPdfFilesWrapper.propTypes = {
  pdfFiles: PropTypes.array.isRequired,
  telemetryData: PropTypes.shape({
    title: PropTypes.string,
    recordAn: PropTypes.string,
  }).isRequired,
  handleOpenPdf: PropTypes.func.isRequired,
};

export default ContentHeaderPdfFilesWrapper;
